export default __webpack_public_path__ + "static/media/svg-2.53f02ef7.svg";